import React, { useCallback, useEffect } from 'react';

import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Outlet } from 'react-router';

import { Carousel } from 'jpi-cloud-web-ui-kit';

import { Link } from '@/components/Link';
import Spacer from '@/components/Spacer';
import useTheme from '@/components/ThemeWrapper/useTheme';

import Footer from '../Footer';

import myUplinkLogo from '@/assets/img/myUplinkPro_logo.png';

import { APP_STATUS_IDLE } from '@/config/common';
import { DEFAULT_BRAND } from '@jpi-cloud-web-pro/jpi-cloud-shared/config/common';

import LanguageSelector from '../LanguageSelector';
import locale from './locale';

import { useCarousel } from './hooks/useCarousel';

import './topmenu.scss'; // FIXME: re-write to styled components and consider using single component for logo

// @ts-ignore next-line
import './signedoutlayout.scss';

type SingOutLayoutProps = {
  url: Record<string, string>;
  status: Record<string, any>;
  isNotAuthPage: boolean;
  languageSelected: string;
};

export const SignOutLayout = ({ url, status, isNotAuthPage, languageSelected }: SingOutLayoutProps) => {
  const { theme, setTheme } = useTheme();
  const noop = useCallback(() => {}, []);
  const slides = useCarousel();

  useEffect(() => {
    if (theme.name !== DEFAULT_BRAND) setTheme(DEFAULT_BRAND);
  }, [theme.name, setTheme]);

  return (
    <div className="welcomePage">
      <div className={`welcomePage__wrapper ${isNotAuthPage ? 'fullHeight' : ''}`}>
        {/* FIXME: Refactor app statuses presentation and setup localizationn */}
        {status?.statusCode?.value !== APP_STATUS_IDLE && <div className="status-banner">{status.statusText}</div>}

        <main className={`welcomePage__contentWrapper ${isNotAuthPage ? 'padding-none' : ''}`}>
          {isNotAuthPage ? (
            // TODO: Move to GuestLayout
            <div className="legalContent__page">
              <div className="legalContent__page__header__wrapper">
                <div className="legalContent__page__header">
                  <div className="logo">
                    <Link to="/" preNavigationCallback={noop}>
                      <img src={myUplinkLogo} alt="MyUplink PRO Logo" />
                    </Link>
                  </div>
                  <LanguageSelector showIcon={false} />
                </div>
              </div>

              <section className="legalContent__page__content fullWidth">
                {/* TODO: Refactor content wrapper for auth and legal pages */}
                <div className="welcomePage__formWrapperContent">
                  <Outlet />
                  <div className="welcomePage__spacer"></div>
                </div>
                <Spacer y={124} />
              </section>
            </div>
          ) : (
            <>
              <div className="welcomePage__logoWrapper">
                <Link to="/" preNavigationCallback={noop}>
                  <img className="welcomePage__logo" src={myUplinkLogo} alt="MyUplink PRO Logo" />
                </Link>
              </div>
              <section className="welcomePage__slideshow welcomePage__slideshow--carousel">
                <Carousel padding={[6, 8, 6]} slideHeight={[52.5, 52.5, 'auto']} slides={slides} />
              </section>
              <section className="welcomePage__formWrapper">
                <div className="welcomePage__formWrapperContent">
                  <div className="welcomePage__menuWrapper">
                    <a href={url && url.WEB_URL} className="welcomePage__menuLink">
                      <FormattedMessage {...locale['unauth.menu.private']} />
                    </a>
                    <a href={url && url.WEB_PRO_URL} className="welcomePage__menuLink active">
                      <FormattedMessage {...locale['unauth.menu.professional']} />
                    </a>
                    <a href={url && url.WEB_DEV_URL} className="welcomePage__menuLink">
                      <FormattedMessage {...locale['unauth.menu.developer']} />
                    </a>
                    <LanguageSelector />
                  </div>

                  {/* TODO: Refactor content wrapper for auth and legal pages */}
                  <Outlet />
                  <div className="welcomePage__spacer"></div>
                </div>
              </section>
            </>
          )}
        </main>

        <Footer isPremiumButtonVisible={false} isAdmin={false} isWelcome={true} languageSelected={languageSelected} />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  languageSelected: state.language.selectedLanguage,
  status: state.app.status,
  url: state.app.url,
});

export default connect(mapStateToProps, null)(SignOutLayout);
